/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Cost_GcInputs */

const en_gc_resources_compare_cost_gc = /** @type {(inputs: Gc_Resources_Compare_Cost_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free to use`)
};

const zh_gc_resources_compare_cost_gc = /** @type {(inputs: Gc_Resources_Compare_Cost_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费使用`)
};

/**
* | output |
* | --- |
* | "Free to use" |
*
* @param {Gc_Resources_Compare_Cost_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_cost_gc = /** @type {((inputs?: Gc_Resources_Compare_Cost_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Cost_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_cost_gc(inputs)
	return zh_gc_resources_compare_cost_gc(inputs)
});
export { gc_resources_compare_cost_gc as "gc.resources.compare.cost.gc" }